export const getTimeToReadInMinutes = (text: string) => Math.ceil(text.length / 1350)